import { useApi } from '@/composables/useApi'

const api = useApi()

export default {
  namespaced: true,
  state: {
    PastaAtual: {},
    videos: [],
    AllVideosMain: [],
    videoEditAtual: {},
  },
  getters: {
    getVideoEditAtual(state) {
      return state.videoEditAtual
    },
  },
  mutations: {
    setVideosMain(state, payload) {
      state.AllVideosMain = payload
    },
    setVideoEditAtual(state, payload) {
      state.videoEditAtual = payload
    },
    resetVideoEditAtual(state) {
      state.videoEditAtual = {}
    },
  },
  actions: {
    async listarVideos({ commit, rootState }) {
      const idPastaAtual = JSON.parse(localStorage.getItem('folderATUAL'))
      if (idPastaAtual === 0) {
        this.PastaAtual = 0
      } else {
        this.PastaAtual = idPastaAtual.id
      }
      return new Promise(async (resolve, reject) => {
        try {
          let params = null
          if (rootState.Folders.folderAtual.id !== null) {
            params = {
              id_folder: this.PastaAtual,
            }
          }

          await api.get(`/vslUserId/${rootState.User.user.id}`, {
            params,
          })
            .then(resp => {
              const formData = resp.data
              formData.map(v => (v.is_selected = false))
              commit('setVideosMain', formData)
              resolve(true)
            })
        } catch (error) {
          reject(error)
        }
      })
    },
  },
}
